import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

export function hyzllist(data) {
  return plaintextrequest({
    url: "/publicH5/hyzllist",
    method: "post",
    data,
  });
}
